enum ActionTypes {
  SET_ASSET_TYPES = 'SET_ASSET_TYPES',
  SET_ASSET_TYPE = 'SET_ASSET_TYPE'
}

export default ActionTypes;
